module.exports = __webpack_public_path__ + "static/media/bluesmall.180a52dd.png";